<template>
  <EditAgencyMargin
    :search-result="searchResult"
    :loading="loading"
    class="wrapper"
    @cancelRequest="cancelRequest"
    @search="search"
  />
</template>

<script>
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdmin } from '@/mixins/setDrawerTypeAdmin'
import { setToolBarTypeAdmin } from '@/mixins/setToolBarTypeAdmin'
import EditAgencyMargin from '@/components/Admin/AgencyMargin/EditAgencyMargin'
import { AgencyMarginRequestRepository } from '@/models/AgencyMarginRequest'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'

export default {
  components: { EditAgencyMargin },
  mixins: [accountInitializer, setDrawerTypeAdmin, setToolBarTypeAdmin],
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    searchResult() {
      return this.$store.getters['agencyMargin/searchResult']
    },
  },
  created() {
    this.search({})
  },
  methods: {
    async search({ keyword }) {
      //結局allで叩けるようになったっぽい
      //      const requestStatus = ['approved', 'rejected', 'waiting', 'cancel']
      const id = undefined
      const requestStatus = 'all'
      this.loading = true
      // if (this.systemOwner.ownerProfileId == null) return
      await this.$store.dispatch('agencyMargin/SEARCH', {
        id,
        requestStatus,
        keyword,
      })
      this.loading = false
    },
    async cancelRequest(requestId) {
      try {
        await AgencyMarginRequestRepository.cancelRequest(requestId)
        this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
          type: snackbarType.ERROR,
          message: '申請を取り消しました',
        })
      } catch (e) {
        throw e
      }
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
</style>
